// extracted by mini-css-extract-plugin
export default {"wrapper":"VIPCustomerSegmentation_wrapper__CzLNK","action-button":"VIPCustomerSegmentation_action-button__3ImdO"};